import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import { Row, Col, Spinner, CardTitle, Form, Label, Table, Modal, ModalBody, Button, ModalHeader } from "reactstrap"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"
import Select from "react-select";
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit";
import apis from "../../api";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//Import Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
const DataTableAffectationSujet = props => {
  const lng = localStorage.getItem("I18N_LANGUAGE")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  //
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [id, setId] = useState("")
  const [modalDecision, setModalDecision] = useState(false)
  const [cycle, setCycle] = useState("")
  const [date, setDate] = useState(new Date())
  const [modalDelete, setModalDelete] = useState(false)
  // Data Table
  const [avisAbsence, setAvisAbsence] = useState([])

  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: avisAbsence.length,
    page: 1,
    nextPageText: props.t("Suivant"),
    prePageText: props.t("Précedent"),
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "300",
        value: 300,
      },
      {
        text: "All",
        value: avisAbsence.length,
      },
    ],
  }

  const NoDataIndication = () => (
      <h6 style={{ textAlign: "center" }}>Aucun information à afficher</h6>
  )
  const Columns = () => [
    {
      dataField: "annee_scolaire",
      text: props.t("Année universitaire"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "enseignant_name",
      text: props.t("Enseignant"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "etudiant_name",
      text: props.t("Etudiant"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "group_name",
      text: props.t("Groupe"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "cycle_name",
      text: props.t("Cycle"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "specialite_name",
      text: props.t("Spécialité"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
      formatter: (cell) => {
        if (!cell) return ""
        const words = cell.split(" ")
        if (words.length > 3) {
          const firstLine = words.slice(0, 3).join(" ")
          const rest = words.slice(3).join(" ")
          return (
            <>
              {firstLine} <br /> {rest}
            </>
          )
        }
        return cell
      },
    },
    {
      dataField: "sujet_name",
      text: props.t("Nom de sujet"),
      sort: true,
      style: { textAlign: "center", whiteSpace: "pre-line" }, // important pour afficher les retours à la ligne
      headerStyle: () => ({ textAlign: "center" }),
      formatter: (cell) => {
        if (!cell) return ""
        const words = cell.split(" ")
        if (words.length > 7) {
          const firstLine = words.slice(0, 7).join(" ")
          const rest = words.slice(7).join(" ")
          return `${firstLine}\n${rest}` // retour à la ligne
        }
        return cell
      },
    },
    {
      dataField: "date_validation",
      text: props.t("Date de soutenance"),
      sort: true,
      style: {textAlign: "center"},
      headerStyle: (colum, colIndex) => {
        return {textAlign: "center"}
      },
    },
    {
      dataField: "etat",
      text: props.t("Etat d'encadrement"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
      formatter: (cell, row) => {
        if (row.etat === 1) {
          return (
            <button className="btn btn-success btn-sm">
              Valider
            </button>
          );
        } else if (row.etat === 2) {
          return (
            <button className="btn btn-danger btn-sm">
              Reporter
            </button>
          );
        }else if (row.etat === 3) {
          return (
            <button className="btn btn-secondary btn-sm">
              En instance
            </button>
          );
        } else {
          return null; // Aucun bouton
        }
      }
    },
    {
      dataField: "Décision",
      isDummyField: true,
      text: props.t("Décision"),
      style: {textAlign: "center"},
      headerStyle: (colum, colIndex) => {
        return {textAlign: "center"}
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        row.sujet_name !== null ? (
          <div style={{display: "flex", justifyContent: "center"}}>
            <i
              style={{color: "rgba(163,12,147,0.44)", cursor: "pointer"}}
              onClick={() => toggleDecision(row)}
              className="fas fa-chalkboard-teacher "
            ></i>
          </div>
        ) : (
          <div style={{display: "flex", justifyContent: "center"}}>
            <i
              style={{color: "#a7a3a3", cursor: "pointer"}}
              className="fas fa-chalkboard-teacher"
              title="Vous pouvez affecter un sujet tous d'abort"
            ></i>
          </div>
        )
      ),
    },
    {
      dataField: "Suppression",
      isDummyField: true,
      text: "Suppression",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        row.etat != 1 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#ED6464", cursor: "pointer" }}
              onClick={() => toggleDelete(row.id)}
              className="fas fa-trash-alt"
            ></i>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#A7A3A3", cursor: "pointer" }}
              className="fas fa-trash-alt"
              title="Cet affectation déjà valider"
            ></i>
          </div>
        ),
    },
  ]
  const toggleValiderDecision = async () => {
    setModalDecision(!modalDecision)
    const res = await apis
      .post("etudiant/valider_affectation", {
        etudiant_ens_pfe_id: id,
        etat: 1,
      }).then(res => {
        const resList = apis
          .post("etudiant/etudiant_effectue_scolarite", { annee_id: annee_id })
          .then(res => {
            setAvisAbsence(res.data.data)
          })
        setLoading(true)
      })
  }
  const toggleDeleteAffectation = async () => {
    setModalDelete(!modalDelete)
    const res = await apis
      .post("etudiant/delete_affectation", {
        etudiant_ens_pfe_id: id
      }).then(res => {
        const resList = apis
          .post("etudiant/etudiant_effectue_scolarite", { annee_id: annee_id })
          .then(res => {
            setAvisAbsence(res.data.data)
          })
        setLoading(true)
      })
  }
  const toggleValiderDecisionDate = async () => {
    setModal(!modal)

  }
  const toggleReporterDecision = async () => {
    setModalDecision(!modalDecision)
    const res = await apis
      .post("etudiant/valider_affectation", {
        etudiant_ens_pfe_id: id,
        etat: 2,
      })
      .then(res => {
        const resList = apis
          .post("etudiant/etudiant_effectue_scolarite", { annee_id: annee_id })
          .then(res => {
            setAvisAbsence(res.data.data)
          })
        setLoading(true)
      })
  }
  const toggleReporterDecisionEnInstance = async () => {
    setModalDecision(!modalDecision)
    const res = await apis
      .post("etudiant/valider_affectation", {
        etudiant_ens_pfe_id: id,
        etat: 3,
      }).then(res => {
        const resList =apis
          .post("etudiant/etudiant_effectue_scolarite", { annee_id: annee_id })
          .then(res => {
            setAvisAbsence(res.data.data)
          })
        setLoading(true)
      })
  }
  const toggleAnnulerDecision = async () => {
    setModalDecision(!modalDecision)
    const res = await apis
      .post("etudiant/valider_affectation", {
        etudiant_ens_pfe_id: id,
        etat: 0,
      }).then(res => {
        const resList =apis
          .post("etudiant/etudiant_effectue_scolarite", { annee_id: annee_id })
          .then(res => {
            setAvisAbsence(res.data.data)
          })
        setLoading(true)
      })
  }
  const toggleDecision = row => {
    setModalDecision(!modalDecision)
    setId(row.id)
    setCycle(row.cycle_id)
  }
  const { SearchBar } = Search

  useEffect(async () => {
    const res = await apis
        .post("etudiant/etudiant_effectue_scolarite", { annee_id: annee_id })
        .then(res => {
          setAvisAbsence(res.data.data)
        })

    setLoading(true)
  }, [])

  useEffect(() => {
    setModal(false)
  }, [avisAbsence])
  const editDate = date => {
    setDate(date)
  }
  const toggle = id => {
    setModal(!modal)
    setId(id)
  }
  const toggleDelete = id => {
    setModalDelete(!modalDelete)
    setId(id)
  }
  const toggleValiderDecisionDateSoutenance = async () => {
    setModal(!modal)
    setModalDecision(!modalDecision)
    if (date !== "") {
      let dateNaiss = date
      let month = "" + (dateNaiss.getMonth() + 1)
      let day = "" + dateNaiss.getDate()
      let year = dateNaiss.getFullYear()
      if (month.length < 2) month = "0" + month
      if (day.length < 2) day = "0" + day
      var convertDate = [year, month, day].join("-")
    } else {
      var convertDate = ""
    }
    const res = await apis
      .post("etudiant/valider_affectation", {
        etudiant_ens_pfe_id: id,
        etat: 1,
        date_validation:date
      }).then(res => {
        const resList = apis
          .post("etudiant/etudiant_effectue_scolarite", {annee_id: annee_id})
          .then(res => {
            setAvisAbsence(res.data.data)
          })
        setLoading(true)
      })
  }
  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Row>
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={avisAbsence}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <div>
                    <Col sm="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar {...toolkitProps.searchProps} />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      noDataIndication={() => <NoDataIndication />}
                      striped={false}
                      bordered={false}
                      classes={"table align-middle table-nowrap"}
                      headerWrapperClasses={"table-light"}
                      hover
                      pagination={paginationFactory(pageOptions)}
                      rowStyle={(row, rowIndex) => {
                        if (row.etat === 1) {
                          return { backgroundColor: "#e0f3e4" } // vert clair
                        } else if (row.etat === 2) {
                          return { backgroundColor: "#fae3e4" } // rouge clair
                        }else if (row.etat === 3) {
                          return { backgroundColor: "#c7f4fd" } // rouge clair
                        }
                        return {} // aucune couleur sinon
                      }}
                      {...toolkitProps.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              {props.t("Chargement en cours...")}
            </h4>
          </div>
        )}
      </div>
      <Modal isOpen={modalDecision} toggle={toggleDecision} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleDecision}
          tag="h4"
        >
          {props.t("Valider / Reporter ")} {props.t("Affectation")}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "15px",
              }}
            >
              <p>
                {props.t("Êtes-Vous sûr de vouloir Valider / Reporter cette")}{" "}
                {props.t("Affectation")} ?
              </p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              {cycle === 2 ? (
                <div>
                  <Button
                    color="success"
                    className="btn-rounded "
                    onClick={toggleValiderDecisionDate}
                  >
                    <i
                      style={{ color: "white" }}
                      className="far fa-thumbs-up"
                    ></i>
                    {props.t("Valider")}
                  </Button>
                </div>
              ) : (
                <div>
                  <Button
                    color="success"
                    className="btn-rounded "
                    onClick={toggleValiderDecision}
                  >
                    <i
                      style={{ color: "white" }}
                      className="far fa-thumbs-up"
                    ></i>
                    {props.t("Valider")}
                  </Button>
                </div>
              )}

              <div>
                <Button
                  onClick={toggleAnnulerDecision}
                  color="warning"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Annuler l'opération")}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleReporterDecision}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Reporter")}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleReporterDecisionEnInstance}
                  color="secondary"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="fas fa-lightbulb"
                  ></i>   {props.t("En instance")}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {props.t("Ajouter une date de soutenance")}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <Row>
              <Col lg="12">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Date de soutenance :
                  </Label>
                  <Col md={6} className="pr-0">
                    <DatePicker
                      className="form-control ddate"
                      selected={date}
                      onChange={editDate}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="dd/MM/yyyy"
                    />
                  </Col>
                </div>
              </Col>
            </Row>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleValiderDecisionDateSoutenance}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {props.t("Oui")}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggle}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Non")}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalDelete} toggle={toggleDelete} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleDelete}
          tag="h4"
        >
          {" Suppression affectation"}{" "}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Voulez-vous supprimer cet affectation ?</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDeleteAffectation}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Oui
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleDelete}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  Non
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}
export default withRouter(withTranslation()(DataTableAffectationSujet))
DataTableAffectationSujet.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
}
